import { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';

const useTracking = ({ params, interval }) => {
  // Params
  const { qtn, organizationKey, orderCode, userId } = params;

  // Mounting reference
  const didMount = useRef(null);

  //State
  const [devicePosition, setDevicePosition] = useState();
  const [error, setError] = useState(null);

  const trackOrder = useCallback(async () => {
    try {
      let response;
      if (orderCode && !qtn) {
        response = await api.traceOrderByCode(orderCode, organizationKey, userId);
      } else {
        response = await api.traceOrder(qtn, organizationKey);
      }
      const { lat, lng } = response.data.devicePosition;
      setDevicePosition({ lat: parseFloat(lat), lng: parseFloat(lng) });
    } catch (networkError) {
      setError(networkError);
    }
  }, [organizationKey, qtn, orderCode, userId]);

  // Fetch at start
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      trackOrder();
    }
  }, [trackOrder]);

  // Fetch device data periodically
  useEffect(() => {
    const trackPeriodically = setInterval(() => {
      trackOrder();
    }, interval);
    return () => clearInterval(trackPeriodically);
  }, [qtn, orderCode, organizationKey, interval, trackOrder]);

  return {
    error,
    devicePosition,
  };
};

export default useTracking;
